import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FULL_API_BASE_URL } from "../../Config/Config";

export const fetchGenderData = createAsyncThunk(
  "api/fetchGenders",
  async () => {
    const response = await fetch(`${FULL_API_BASE_URL}/get-gender-list/`);
    const data = await response.json();
    return data;
  }
);

const genderSlice = createSlice({
  name: "gender",
  initialState: {
    genderdata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGenderData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGenderData.fulfilled, (state, action) => {
        state.loading = false;
        state.genderdata = action.payload;
      })
      .addCase(fetchGenderData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default genderSlice.reducer;
